import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, inject } from '@angular/core';
import { Component } from '@angular/core';
import { ConfirmationDialogData } from '@ebeihilfe/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ebeihilfe-portal-confirm-modal',
  templateUrl: './confirm-dialog.component.html',
  standalone: true,
  imports: [TranslateModule, MatDialogModule, MatButtonModule, A11yModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  public data = inject<ConfirmationDialogData>(MAT_DIALOG_DATA);
}
